import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

const SubCategoryView = () => {
  const [sub, setSub] = useState({
    subcategory_name: "",
    category_id: "",
    image: "",
  });

  const { id } = useParams();

  useEffect(() => {
    const fetchSub = async () => {
      try {
        const response = await axios.post(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/get_id_main_subcategory",
          { subcategory_id: id }
        );

        if (response.data?.subcategory) {
          setSub(response.data.subcategory);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchSub();
  }, [id]);

  return (
    <div className="page-content">
      <div className="container-fluid">

        {/* TITLE */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Sub Categories View</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to="javascript:void(0);">Sub Categories</Link>
                </li>
                <li className="breadcrumb-item active">Sub Categories View</li>
              </ol>
            </div>
          </div>
        </div>

        {/* VIEW CARD */}
        <div className="row">
          <div className="col-xl-12">
            <div className="card Subcategory-view">

              {/* Close Icon */}
              <div className="cross-icon">
                <Link to="/sub-category-list">
                  <i className="fa-solid fa-circle-xmark"></i>
                </Link>
              </div>

              {/* IMAGE */}
              <div>
                <img
                  src={`https://cyberathon.com/multivendor/${sub.image}`}
                  width={600}
                  height={400}
                  alt="Subcategory"
                />
              </div>

              {/* NAME */}
              <strong>Sub Category Name</strong>
              <p>{sub.subcategory_name}</p>

              {/* CATEGORY ID (since API doesn't return name) */}
              <strong>Category ID</strong>
              <p>{sub.category_id}</p>

            </div>
          </div>
        </div>

      </div>

      {/* FOOTER */}
      <footer className="footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 text-center">
              © Venton. Crafted by{" "}
              <iconify-icon
                icon="iconamoon:heart-duotone"
                className="fs-18 align-middle text-danger"
              />
              <Link to="#" className="fw-bold footer-text" target="_blank">
                Techzaa
              </Link>
            </div>
          </div>
        </div>
      </footer>

    </div>
  );
};

export default SubCategoryView;
